export default function FormCanceled() {
  return <div>Ihr Formular wurde erfolgreich ausgefüllt.</div>;
}
